import { routes } from "@/constants/routes";
import { Redirect } from "expo-router";

/** Die Mandanten-Medikation gibt es nicht mehr. */
export default function MedicationRedirect() {
  return <Redirect href={routes.home} />;
}
